import styled from '@emotion/styled';
import { motion } from 'motion/react';
import { Link } from 'react-router';

export const Wrapper = styled(motion.div)`
  height: 100dvh;
  background: #171717;
  width: 70px;
  position: relative;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 48px;

  /* border-top-right-radius: 1px;
  border-bottom-right-radius: 1px; */
  overflow-x: hidden;
`;

export const Header = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 24px;
  background-color: #171717;
  min-height: 52px;
`;

export const NavList = styled(motion.div)<{ collapsed?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  gap: 2px;
  flex: 1;
`;

export const NestedNavList = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding-left: 36px;
  width: 100%;
`;

export const StyledNavItem = styled(Link)<{ collapsed?: boolean }>`
  padding: ${({ collapsed }) => (collapsed ? '12px' : '12px')};
  width: ${({ collapsed }) => (collapsed ? '48px' : '100%')};
  height: ${({ collapsed }) => (collapsed ? '48px' : 'auto')};
  display: flex;
  align-items: center;
  justify-content: ${({ collapsed }) => (collapsed ? 'center' : 'flex-start')};
  border-radius: ${({ collapsed }) => (collapsed ? '16px' : '16px')};
  transition:
    background-color 0.2s ease,
    width 0.2s,
    height 0.2s,
    padding 0.2s;

  white-space: nowrap;
  overflow: hidden;

  &:hover {
    background-color: #333;
  }
`;

export const NavItem = motion.create(StyledNavItem);

export const Overlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 70;
  right: 0;
  bottom: 0;
  width: calc(100vw - 70px);
  height: max(100vh, 100dvh);
  z-index: 90;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: all;
`;

export const Footer = styled(motion.div)`
  padding-right: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
